(function () {
  const isMobile = () =>
    window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(max-width: 900px)').matches;

  function buildVideoEl(src, className) {
    const v = document.createElement('video');
    v.className = className || '';
    v.controls = true;
    v.playsInline = true;       // iOS inline allowed
    v.preload = 'metadata';
    const s = document.createElement('source');
    s.src = src;
    s.type = 'video/mp4';
    v.appendChild(s);
    return v;
  }

  function openMobileFullscreen(src, openerBtn) {
    const overlay = document.createElement('div');
    overlay.className = 'fs-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Video player');

    const header = document.createElement('div');
    header.className = 'fs-header';

    const closeBtn = document.createElement('button');
    closeBtn.className = 'fs-close';
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close video');
    closeBtn.textContent = '×';

    header.append(closeBtn);

    const body = document.createElement('div');
    body.className = 'fs-body';

    const video = buildVideoEl(src, 'fs-video');
    body.appendChild(video);
    overlay.append(header, body);
    document.body.appendChild(overlay);

    // Set portrait/landscape class once metadata is ready
    video.addEventListener('loadedmetadata', () => {
      const isPortrait = video.videoHeight > video.videoWidth;
      overlay.classList.toggle('is-portrait', isPortrait);
      overlay.classList.toggle('is-landscape', !isPortrait);
    });

    const tryEnterFullscreen = (el) => {
      try {
        if (el.requestFullscreen) { el.requestFullscreen(); return true; }
        if (el.webkitRequestFullscreen) { el.webkitRequestFullscreen(); return true; } // older Safari
      } catch (_) {}
      return false;
    };
    const tryExitFullscreen = () => {
      try {
        if (document.fullscreenElement && document.exitFullscreen) document.exitFullscreen();
        if (document.webkitFullscreenElement && document.webkitExitFullscreen) document.webkitExitFullscreen();
      } catch (_) {}
    };
    const cleanup = () => {
      try { video.pause(); } catch (_) {}
      video.currentTime = 0;
      tryExitFullscreen();
      overlay.remove();
      openerBtn?.focus?.();
    };

    closeBtn.addEventListener('click', cleanup);
    overlay.addEventListener('keydown', (e) => { if (e.key === 'Escape') { e.preventDefault(); cleanup(); } });

    // Start playback (user gesture)
    video.play().catch(() => {});

    // Prefer fullscreening the OVERLAY so the × remains visible
    let wentFS = tryEnterFullscreen(overlay);

    // iOS legacy fallback: native video fullscreen
    if (!wentFS && typeof video.webkitEnterFullscreen === 'function') {
      try {
        video.webkitEnterFullscreen();
        video.addEventListener('webkitendfullscreen', cleanup, { once: true });
      } catch (_) {}
    }
  }

  function openDesktopLightbox(src, openerBtn) {
    if (typeof window.basicLightbox === 'undefined') {
      console.error('basicLightbox not found. Include its script.');
      return;
    }

    const titleEl = document.querySelector('[data-product-title]');
    const title = titleEl ? titleEl.dataset.productTitle : '';

    const html = `
      <div class="blb-dialog" role="dialog" aria-modal="true" aria-label="Video player">
        <header class="blb-header">
          <div class="blb-title">${title}</div>
          <button class="blb-close" aria-label="Close video">
            <span class="icon-button icon-button-close icon-button--small">
              <span class="icon-button__icon">
                <span class="icon icon-new icon-close">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.66 1.34 2 .68.68 2l.66.66 1.32-1.32zm18.68 21.32.66.66L23.32 22l-.66-.66-1.32 1.32zm1.32-20 .66-.66L22 .68l-.66.66 1.32 1.32zM1.34 21.34.68 22 2 23.32l.66-.66-1.32-1.32zm0-18.68 10 10 1.32-1.32-10-10-1.32 1.32zm11.32 10 10-10-1.32-1.32-10 10 1.32 1.32zm-1.32-1.32-10 10 1.32 1.32 10-10-1.32-1.32zm0 1.32 10 10 1.32-1.32-10-10-1.32 1.32z" fill="currentColor"></path></svg>
                </span>
              </span>
            </span>
          </button>
        </header>
        <main class="blb-content">
          <video id="blbVideo" class="modal-video" controls playsinline preload="metadata">
            <source src="${src}" type="video/mp4">
            Sorry, your browser doesn’t support embedded videos.
          </video>
        </main>
      </div>
    `;

    const instance = basicLightbox.create(html, {
      onShow: (inst) => {
        const root = inst.element();
        const dialog = root.querySelector('.blb-dialog');
        const video = root.querySelector('#blbVideo');
        const closeBtn = root.querySelector('.blb-close');

        // Portrait/landscape class on metadata ready
        video.addEventListener('loadedmetadata', () => {
          const isPortrait = video.videoHeight > video.videoWidth;
          dialog.classList.toggle('is-portrait', isPortrait);
          dialog.classList.toggle('is-landscape', !isPortrait);
        });

        closeBtn.addEventListener('click', () => inst.close());

        // Autoplay: try with sound (desktop allows it); if the browser blocks
        // it (mobile autoplay policy), fall back to muted autoplay so it still
        // starts. The visitor can unmute via the controls.
        const playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(() => {
            video.muted = true;
            video.play().catch(() => {});
          });
        }

        root.addEventListener('basiclightbox:close', () => {
          try { video.pause(); } catch (_) {}
          video.currentTime = 0;
          openerBtn?.focus?.();
        });
      },
      onClose: () => {
        const video = document.getElementById('blbVideo');
        if (video) {
          try { video.pause(); } catch (_) {}
          video.currentTime = 0;
          openerBtn?.focus?.();
        }
      }
    });

    instance.show();
    return instance;
  }

  // Programmatic API used by the gallery auto-open-on-swipe
  window.openProductVideoModal = openDesktopLightbox;

  // Wire up every .video-circle on the page
  document.querySelectorAll('.video-circle, [data-video-trigger]').forEach((btn) => {
    const preview = btn.querySelector('.circle-preview');

    // Determine per-button main video source:
    // Prefer data-video-src, else fallback to the first <source> in preview
    let src = btn.getAttribute('data-video-src');
    if (!src && preview) {
      const firstSource = preview.querySelector('source');
      if (firstSource && firstSource.src) src = firstSource.src;
    }

    if (!src) {
      console.warn('No video source found for .video-circle. Provide data-video-src or a <source> inside .circle-preview.', btn);
      return; // skip wiring this circle
    }

    // Keep each preview efficient (pause when off-screen)
    // The preview element is a <video> only when the theme's video_preview_mode is
    // 'autoplay'; in poster mode it is an <img>, which has no play()/pause().
    // Feature-test the element rather than branching on the mode, so this stays
    // correct for any element a caller puts here.
    const isPlayable = preview && typeof preview.play === 'function';
    if ('IntersectionObserver' in window && isPlayable) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(({ isIntersecting }) => {
          if (isIntersecting) {
            if (preview.dataset.lazySrc && !preview.src) preview.src = preview.dataset.lazySrc;
            preview.muted = true;
            preview.play().catch(() => {});
          } else {
            try { preview.pause(); } catch (_) {}
          }
        });
      }, { threshold: 0.2 });
      io.observe(preview);
    }

    const open = () => openDesktopLightbox(src, btn);

    btn.addEventListener('click', open);
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        open();
      }
    });
  });
})();
